const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const PRIMARY_API_BASE = 'https://api.braisepos.com';
const LEGACY_RENDER_FALLBACK = 'https://eataz.onrender.com/api'; // TODO(braise-cutover): remove once all traffic moves to api.braisepos.com
const LOCAL_FALLBACK = '/api';

const resolveBaseFromEnv = (): string | null => {
  const fromEnv = import.meta.env.VITE_API_BASE_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim().length > 0) {
    return trimTrailingSlash(fromEnv.trim());
  }
  return null;
};

const inferRuntimeBase = (envBase: string | null): string => {
  if (envBase) {
    return envBase;
  }

  if (typeof window === 'undefined') {
    return PRIMARY_API_BASE;
  }

  const hostname = window.location.hostname.toLowerCase();
  const origin = window.location.origin.replace(/\/+$/, '');

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost') ||
    hostname.endsWith('.local')
  ) {
    return LOCAL_FALLBACK;
  }

  if (hostname.includes('eataz')) {
    return LEGACY_RENDER_FALLBACK;
  }

  if (origin.endsWith('.onrender.com')) {
    return `${origin}/api`;
  }

  return PRIMARY_API_BASE;
};

const resolvedBase = inferRuntimeBase(resolveBaseFromEnv());

export const API_BASE = trimTrailingSlash(resolvedBase || LEGACY_RENDER_FALLBACK);

